import React from "react";
import { Users, ChevronRight } from "lucide-react";

const fmt = (n) => (n ?? 0).toLocaleString("en-IN");

const Sparkline = ({ points = [], height = 28 }) => {
  if (!points || points.length < 2) {
    return <div style={{ height }} className="bg-[hsl(var(--surface-elevated))]" />;
  }
  const values = points.map((p) => p.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = Math.max(1, max - min);
  const W = 120;
  const H = height;
  const step = W / (points.length - 1);
  const d = points
    .map((p, i) => `${i === 0 ? "M" : "L"} ${i * step} ${H - ((p.value - min) / span) * (H - 4) - 2}`)
    .join(" ");
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full" preserveAspectRatio="none" style={{ height }}>
      <path d={`${d} L ${W} ${H} L 0 ${H} Z`} fill="hsl(var(--primary) / 0.15)" />
      <path d={d} fill="none" stroke="hsl(var(--primary))" strokeWidth="1.5" />
    </svg>
  );
};

const barColor = (pct) =>
  pct >= 0.85 ? "hsl(var(--destructive))" :
  pct >= 0.7  ? "hsl(var(--warning))" :
  pct >= 0.5  ? "hsl(var(--primary))" :
                "hsl(217 91% 60%)";

export const ZoneOccupancyCard = ({ zone, history, onClick }) => {
  const cap = zone.capacity ?? 0;
  const occ = zone.current_occupancy ?? zone.occupancy ?? 0;
  const pct = cap ? occ / cap : 0;
  const pctInt = Math.round(pct * 100);

  return (
    <button
      onClick={onClick}
      data-testid={`zone-card-${zone.id}`}
      className="panel p-3 text-left hover:bg-[hsl(var(--surface-elevated))] transition-colors group flex flex-col gap-2 min-w-0"
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="font-display font-bold uppercase tracking-tight text-xs leading-tight truncate">
            {zone.name}
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground mt-0.5">
            {zone.type} · cap {fmt(cap)}
          </div>
        </div>
        <ChevronRight className="w-3.5 h-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 shrink-0 transition-opacity" />
      </div>

      <div className="flex items-baseline gap-1.5">
        <div className="font-mono text-xl font-semibold tracking-tighter leading-none">
          {fmt(occ)}
        </div>
        <div className={`font-mono text-xs uppercase tracking-widest ${pctInt >= 85 ? "sev-critical" : pctInt >= 70 ? "sev-medium" : "text-muted-foreground"}`}>
          {pctInt}%
        </div>
        <div className="ml-auto flex items-center gap-1 text-[10px] text-muted-foreground">
          <Users className="w-3 h-3" />
        </div>
      </div>

      {/* Capacity bar */}
      <div className="h-1 bg-border w-full">
        <div
          className="h-full transition-all"
          style={{ width: `${Math.min(100, pctInt)}%`, background: barColor(pct) }}
        />
      </div>

      {/* Sparkline */}
      <Sparkline points={history ?? []} />
    </button>
  );
};

export default ZoneOccupancyCard;
